module.exports = __webpack_public_path__ + "img/p1440_logo.42a8461f.png";